export type Action = "view" | "manage" | "create" | "update" | "delete";

export type ResourcePermissions = {
  [resource: string]: {
    [action in Action]?: boolean;
  };
};

export type PermissionAttributes = {
  permissions?: ResourcePermissions;
};

export function hasPermission(
  permissions: PermissionAttributes,
  resource: string,
  action: Action,
  data?: any,
): boolean {

  if (permissions.permissions?.[resource]) {
    const resourcePermissions = permissions.permissions[resource];
    if (resourcePermissions[action] !== undefined) {
      return resourcePermissions[action] as boolean;
    }
  }

  return false
}


export function canSeeDashboard(permissions: PermissionAttributes): boolean {
  return hasPermission(permissions, "dashboard", "view");
}

export function canManageReceipts(permissions: PermissionAttributes): boolean {
  return hasPermission(permissions, "receipts", "manage");
}

export function canManageProgram(permissions: PermissionAttributes): boolean {
  return hasPermission(permissions, "program", "manage");
}

export function canManageUsers(permissions: PermissionAttributes): boolean {
  return hasPermission(permissions, "users", "manage");
}

export function canManageRewards(permissions: PermissionAttributes): boolean {
  return hasPermission(permissions, "rewards", "manage");
}

export function canManageChallenges(
  permissions: PermissionAttributes,
): boolean {
  return hasPermission(permissions, "challenges", "manage");
}

export function canManageOrganization(
  permissions: PermissionAttributes,
): boolean {
  return hasPermission(permissions, "organization", "manage");
}

export function canSeeGlobalSearch(permissions: PermissionAttributes): boolean {
  return hasPermission(permissions, "global_search", "view");
}
